<template>
    <div class="animated fadeIn container-fluid page-content">
        <SectionTitle :title="'Văn bản chỉ đạo'" />
        <div class="text-center" v-if="!listDocuments.length">Không có bản ghi nào</div>
        <b-row v-else class="mt-4 mx-1">
            <b-col sm="6" md="4" lg="3" xl="2" v-for="(item, index) in listDocuments" :key="index">
                <b-card
                    border-variant="light"
                    class="card-doc cursor-pointer"
                    :img-src="
                        item.avatar
                            ? `${API_CONFIG.URL_GET_FILE}${item.avatar}`
                            : '/img/image_doc.jpeg'
                    "
                    img-height="190px"
                    img-alt="Ảnh"
                    img-top
                >
                    <b-card-title
                        class="text-primary font-15 font-weight-bold document-content"
                        @click="getInfo(item.id)"
                        >{{ item.name }}</b-card-title
                    >
                    <b-card-text class="text-muted">{{ item.date | formatDate }}</b-card-text>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import SectionTitle from '@/components/SectionTitle';
import { mapState, mapActions } from 'vuex';

export default {
    components: {
        SectionTitle
    },
    computed: {
        ...mapState({
            listNews: (state) => state.news.items,
            isMobile: (state) => state.page.isMobile
        }),
        listDocuments() {
            return this.listNews.filter((item) => item.type == 'DOCUMENT');
        }
    },
    methods: {
        ...mapActions({
            getListNews: 'news/getList'
        }),
        getInfo(newsId) {
            this.$router.push(`/news/${newsId}`);
        }
    },
    created() {
        this.getListNews();
    }
};
</script>
